<template>
    <el-dialog title="帮扶中心众筹招股"
               :visible.sync="zhaoguShow"
               width="80%">
        <div class="lottery">
            <span v-for="(item, index) in lottery.arr"
                  :key="index"
                  :class="lottery.active == index?'active':''"
                  @click="lottery.active = index">{{item}}</span>
            <div class="msg">实体投注站帮扶中心</div>
        </div>
        <div class="sub">
            <span>众筹招股投注站战绩</span>
            <span class="btn">投注站申请帮扶</span>
            <div class="msg">
                <span>实战超市方案价格+方案本金=实战总额</span>
                <span>1元=1缩币</span>
                <span>开奖当前20:00以后可以查阅实战方案</span>
            </div>
        </div>
        <div class="tit">
          <div>
            <h3>{{ lottery.db[lottery.index] && lottery.db[lottery.index].dictLabel }}{{ latestIssue }}期实战团队方案汇总</h3>
            <div>
                    <span @click="toggleNumber('latestIssue',0)"
                          :class="{active:flagMark==0}">最新期</span>
              <span @click="toggleNumber('prev',1)"
                    :class="{active:flagMark==1}">上一期</span>
              <span @click="toggleNumber('next',2)"
                    :class="{active:flagMark==2}">下一期</span>
            </div>
          </div>
          <div class="btn">篮球由彩票代表确定</div>
          <!-- <div>双色球开奖结果：每周二、四、日21:30</div> -->
          <div v-if="lottery.active == 0">双色球开奖结果：每周二，四，日 21：30</div>
          <div v-if="lottery.active == 1">大乐透开奖结果：每周一，三，六 21：25</div>
          <div v-if="lottery.active == 2">福彩3D开奖结果：每日 21：15（3d试机号18:30）</div>
          <div v-if="lottery.active == 3">排列三开奖结果：每日 20：45</div>
        </div>
        <el-table v-loading="tableLoading"
                  :data="list"
                  :header-cell-style="{'textAlign':'center'}"
                  :cell-style="{'textAlign':'center'}">
            <el-table-column label="序号"></el-table-column>
            <el-table-column label="期号"></el-table-column>
            <el-table-column label="投注站站号"></el-table-column>
            <el-table-column label="投注站地址"></el-table-column>
            <el-table-column label="众筹招股"
                             width="150"></el-table-column>
            <el-table-column label="总股数"></el-table-column>
            <el-table-column label="分享二维码"></el-table-column>
            <el-table-column label="股权清单"></el-table-column>
            <el-table-column label="认购状态"></el-table-column>
            <el-table-column label="上传实战票"></el-table-column>
            <el-table-column label="兑奖明细"></el-table-column>
        </el-table>

        <div class="tableMsg">目前开放双色球和大乐透，仅实体投注站可以认购</div>

        <div class="fenye">
            <span class="zhanwei"></span>
            <el-pagination background
                           layout="prev, pager, next"
                           :total="1000">
            </el-pagination>
            <div>自定义期号<input type="text" /><span>搜索</span></div>
        </div>

    </el-dialog>
</template>

<script>
import {queryLotteryType} from "@/api/common";
import {GetLotteryList, GetLotteryTeam, schemelist} from "@/api/personalCenter";

export default {
    data () {
      return {
        zhaoguShow: false,
        lottery: {
          db: [],
          active: '0',
          index: 0
        },

        list: [],

        yingkui_show: false,

        lotteryTeam: [],

        tableLoading: true,
        listPagin: {
          page: 1,
          limit: 10,
          total: 0
        },


        latestIssue: '',  //最新期

        isTogglenumber: true,  //是否点击了上一期下一期按钮

        flagMark: 0,  //期号标记   最新期，上一期，下一期
      }

    },
  mounted () {

    new Promise(resolve => {
      // 获取彩种
      queryLotteryType().then(res => {
        console.log('res(queryLotteryType)', res);
        let lotteryDb = res.data.map(item => { return { dictLabel: item.dictLabel, dictValue: item.dictValue } })
        this.lottery.db = lotteryDb.splice(0, 2)
        this.getList()
        resolve()
      })
    }).then(res => {
      return new Promise(resolve => {
        // console.log('2');
      })
    })

    // 获取彩种团队
    GetLotteryTeam().then(res => {
      res.forEach(item => {
        item.list = item.list.map(team => ({ active: false, name: team }));
      });
      this.lotteryTeam = res
    })
  },
  methods: {
    getList (isTeam, teamName = '') {
      let fn = isTeam ? GetLotteryList : schemelist,
          params = {
            pageNum: this.listPagin.page,
            pageSize: this.listPagin.limit,
            preType: this.lottery.active,
            preNumber: this.latestIssue,	//期数（不传默认最新期）
            type:'0'
          },
          teamParams = {
            preType: this.lottery.active,
            teamName,
          }

      fn(isTeam ? teamParams : params).then(res => {
        console.log('res（fn）',res);
        this.tableLoading = false
        if (res.length>0){
          this.list=res;
        }

        if (this.isTogglenumber) {
          this.latestIssue = res.lastNumber
        }

        if (res.marketInfos.length>0) {
          this.list = res.marketInfos.rows
          this.listPagin.total = res.marketInfos.total
        }
      })
    },
    // 分页状态变化
    changePage (e) {
      this.tableLoading = true
      this.listPagin.page = e
      this.getList();
    },
    // 切换期号
    toggleNumber (tag, index) {
      this.isTogglenumber = false
      this.flagMark = index

      if (index == 0) {
        this.latestIssue = ''
        this.isTogglenumber = true
      } else {
        tag == 'prev' ? this.latestIssue-- : tag == 'next' ? this.latestIssue++ : ''
      }
      this.getList()
    },
    // 点击切换团队
    toggleTeam (ite) {
      console.log('item', ite);
      this.lotteryTeam.forEach(item => item.list.forEach(team => team.active = false));
      ite.active = true
      this.getList('team', ite.name)
    }
  }
}
</script>

<style lang="scss" scoped>
.lottery {
    border: 1px solid rgba(0, 0, 0, 0.2);
    position: relative;
    span {
        background-color: #dbdbdb;
        padding: 20px 70px;
        display: inline-block;
        cursor: pointer;
        &.active {
            background-color: #ffffff;
        }
    }
    .msg {
        color: #951d1d;
        position: absolute;
        right: 10px;
        bottom: 4px;
        font-weight: bold;
        font-size: 40px;
    }
}
.sub {
    padding: 0 20px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    span {
        padding: 20px 0px;
        &.btn {
            background-color: #347caf;
            color: #ffffff;
            padding: 5px 10px;
            border-radius: 5px;
        }
    }
    .msg {
        width: 60%;
        display: flex;
        justify-content: space-between;
        position: absolute;
        top: 15px;
        bottom: 0;
        left: 20%;
        color: #898af7;
        span {
            // margin-right: 50px;
        }
    }
}
.tit {
    border: 1px solid rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    > div {
        display: flex;
        align-items: center;
        margin: 0 20px;
        h3 {
            color: #347caf;
        }
        &.btn {
            background-color: #347caf;
            color: #ffffff;
            padding: 5px 10px;
            border-radius: 5px;
        }
        > div {
            margin-left: 20px;
            span {
                background-color: #dbdbdb;
                padding: 5px 10px;
                border-radius: 5px;
                margin-right: 20px;
                &.active {
                    background-color: #93d2f3;
                }
            }
        }
    }
}
.tableMsg {
    margin-top: 10px;
    text-align: center;
    color: #898af7;
    font-weight: bold;
}
.fenye {
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .zhanwei {
        width: 25%;
    }
}
</style>